import type { PlatformKind } from './types'

/**
 * Выбор адаптера платформы.
 * Есть непустой initData → TELEGRAM, иначе BROWSER.
 * Форсировать можно query-параметром ?platform=browser (удобно для скриншотов внутри TG-девтулов).
 */
export function detectPlatformKind(): PlatformKind {
  if (typeof window === 'undefined') {
    return 'BROWSER'
  }

  const forced = new URLSearchParams(window.location.search).get('platform')
  if (forced === 'browser') {
    return 'BROWSER'
  }

  const initData = window.Telegram?.WebApp?.initData
  return initData ? 'TELEGRAM' : 'BROWSER'
}
